export const initialLogin = {
    mobile: "",
    password: "",
    token: "",
};
export let pathsLogin = {
// Note: populated in reducer
};
export const initialRequestVerify = {
    mobile: ""
};
export var pathsRequestVerify = {
// Note: populated in reducer
};
export const initialVerify = {
    mobile: "",
    code: "",
    newPassword: "",
    newPasswordConfirm: ""
};
export var pathsVerify = {
// Note: populated in reducer
};
export const initialForgotPassword = {
    mobile: "",
};
export var pathsForgotPassword = {
// Note: populated in reducer
};
export const initialResetPassword = {
    mobile: "",
    code: "",
    newPassword: "",
    newPasswordConfirm: ""
};
export var pathsResetPassword = {
// Note: populated in reducer
};
//--------------------------------------------------------------------------------------
